import { AppDefinition } from '../../types/apps';

export const PromptLibraryAppDefinition: AppDefinition = {
  appId: 'prompt-library',
  name: 'Prompt Library',
  version: '1.0.0',
  description: 'Browse, customize, and create prompt templates',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'BookOpen',
    phosphorWeight: 'duotone',
    color: '#3b82f6',
  },
  supportedFileTypes: [],
  events: {},
  entityTypes: ['PromptTemplate'],
  component: 'PromptLibraryApp',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  experimental: true,
};


